import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '$hooks';
import { IWebRef } from '$models';
import { Link } from '$components/elements/link';
import { Flex } from '$components/layouts';
import { SvgIcon } from '$components/elements/svg-icon';
import { Text } from '$components/elements/text';
import { theme } from '$theme';

type Props = {
    data: IWebRef;
    productTitle?: string;
};

export const ReadRef: FC<Props> = (props: Props): JSX.Element => {
    const { data, productTitle } = props;
    const { translate } = useTranslation();
    if (!data.uri) {
        return <></>;
    }

    return (
        <DetailsContainer gap="medium">
            <Link href={data.uri}>
                <SvgContainer>
                    <SvgIcon size="md" svg="download" color={theme.colors.white} />
                </SvgContainer>
            </Link>
            <Flex column>
                <Text noSpacing h4 size="20px">
                    {translate('productPage.webRefs.read')}
                </Text>
                <DimmedText>{productTitle}</DimmedText>
            </Flex>
        </DetailsContainer>
    );
};

const DetailsContainer = styled(Flex)(({ theme }) => ({
    alignItems: 'center',
    border: `1px solid ${theme.colors.grey10}`,
    backgroundColor: theme.colors.grey5,
    borderRadius: '6px',
    padding: `${theme.space[4]} ${theme.space[5]}`,
    marginBottom: theme.space[9],
}));

const SvgContainer = styled(Flex)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '48px',
    height: '48px',
    backgroundColor: theme.colors.red500,
    borderRadius: theme.general.circleRadius,
}));

const DimmedText = styled(Text)(({ theme }) => ({
    color: theme.colors.textSubtle,
    fontSize: theme.fontSizes.xxs,
}));
